export const auth_token =
  "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoicmVhZGVycyJ9.tQsDDw-0sJl-0TcsWN8ne2rMktsAlLO-9zaukGHT3SA";
